module.exports = __webpack_public_path__ + "img/6H.84564e31.png";